import { KisiLock } from "@gymflow/types";
import { mutationOptions, QueryKey, queryOptions } from "@tanstack/react-query";

import { api } from "../../api";
import { queryClient } from "../../QueryClient";

const keys = {
  all: () => ["memberApiAccess"] as QueryKey,
  perUser: (userId: unknown) => [...keys.all(), "perUser", userId] as QueryKey,
  locks: (userId: unknown, deviceId: unknown) =>
    [...keys.perUser(userId), "locks", deviceId] as QueryKey,
  secrets: (userId: unknown, deviceId: unknown) =>
    [...keys.perUser(userId), "secrets", deviceId] as QueryKey,
  upcomingAccess: (userId: unknown) =>
    [...keys.perUser(userId), "upcomingAccess"] as QueryKey,
};

export const memberApiAccess = {
  keys,
  queries: {
    locks: (userId: string | undefined, deviceId: string | undefined) =>
      queryOptions({
        queryKey: keys.locks(userId, deviceId),
        queryFn: async () => {
          return (await api.get<KisiLock[]>(`/catalog/kisi/locks/${deviceId}`))
            .data;
        },
        enabled: !!userId && !!deviceId,
      }),
    secrets: (userId: string | undefined, deviceId: string | undefined) =>
      queryOptions({
        queryKey: keys.secrets(userId, deviceId),
        queryFn: async () => {
          return (await api.get(`/customer/kisi/login-credentials/${deviceId}`))
            .data as {
            loginId: string;
            secret: string;
            phoneKey: string;
            certificate: string;
            primaryLogin: boolean;
          };
        },
        enabled: !!userId && !!deviceId,
      }),
    upcomingAccess: (userId: string | undefined) =>
      queryOptions({
        queryKey: keys.upcomingAccess(userId),
        queryFn: async () => {
          return (
            await api.get<
              | {
                  bookingName: string;
                  startAt: string;
                  endAt: string;
                }
              | undefined
            >(`/customer/user-member-booking/upcoming-access`)
          ).data;
        },
      }),
  },
  infiniteQueries: {},
  mutations: {
    promoteLogin: () =>
      mutationOptions({
        mutationFn: async ({
          deviceId,
        }: {
          userId: string;
          deviceId: string;
        }) => {
          return (await api.put(`/customer/kisi/promote-login/${deviceId}`)).data;
        },
        onSettled: async (_, __, { userId }) => {
          await queryClient.invalidateQueries({
            queryKey: keys.perUser(userId),
          });
        },
      }),
  },
};
